import React from 'react'

export const MultipleQuestion = ({id,text_value,correct}) => {
    return (
        <div className="btn-question" key={id}><input type="checkbox" key={id} id={id} className="opt-question" value={correct}/> {text_value} <br/></div>
    )
}
